export default {"src":"https://fishbrain.com/_next/static/media/sunIconGray.c7ea99f0.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};